import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { BizMenuPageScreenActionSettingModalComponent } from './biz-menu-page-screen-action-setting-modal.component';
import { BizMenuPageScreenActionSettingService } from './biz-menu-page-screen-action-setting-modal.service';

/**
 * 業務メニュー画面動作設定モジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    TooltipModule
  ],
  declarations: [
    BizMenuPageScreenActionSettingModalComponent
  ],
  entryComponents: [
    BizMenuPageScreenActionSettingModalComponent
  ],
})
export class BizMenuPageScreenActionSettingModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: BizMenuPageScreenActionSettingModule,
      providers: [
        BizMenuPageScreenActionSettingService,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/biz-menu-page-screen-action-setting-modal/biz-menu-page-screen-action-setting-modal.module.ts